export const viewTitle = "Лист фонда";
export const viewUniqKey = "fundListReport";
